"use client";

import { useContext } from "react";
import { ToastContext, type ToastProps } from "@/components/ui/toast";

export function useToast() {
  const { toasts, addToast, removeToast, updateToast } =
    useContext(ToastContext);

  function toast(props: ToastProps) {
    return addToast(props);
  }
  toast.dismiss = (id: string) => {
    removeToast(id);
  };
  toast.update = (id: string, props: Partial<ToastProps>) => {
    updateToast(id, props);
  };

  return { toasts, toast };
}